export const REPORT_STATUSES = [
  //{ key: "ALL", text: "All", value: "" },
  { key: "SUBMITTED", text: "Submitted", value: "SUBMITTED" },
  {
    key: "PENDING_APPROVAL",
    text: "Pending Approval",
    value: "PENDING_APPROVAL",
  },
  { key: "APPROVED", text: "Approved", value: "APPROVED" },
  { key: "QUEUED", text: "Queued", value: "QUEUED" },
  { key: "PROCESSING", text: "Processing", value: "PROCESSING" },
  { key: "COMPLETED", text: "Completed", value: "COMPLETED" },
  { key: "FAILED", text: "Failed", value: "FAILED" },
  { key: "CANCELLED", text: "Cancelled", value: "CANCELLED" },
  { key: "REJECTED", text: "Rejected", value: "REJECTED" },
];

export const REPORT_STATUS_COLORS = {
  SUBMITTED: { bg: "#e3f2fd", text: "#1976d2", label: "Submitted" },
  PENDING_APPROVAL: {
    bg: "#fff3e0",
    text: "#f57c00",
    label: "Pending Approval",
  },
  APPROVED: { bg: "#e8f5e9", text: "#388e3c", label: "Approved" },
  QUEUED: { bg: "#f3e5f5", text: "#7b1fa2", label: "Queued" },
  PROCESSING: { bg: "#e1f5fe", text: "#0288d1", label: "Processing" },
  COMPLETED: { bg: "#c8e6c9", text: "#2e7d32", label: "Completed" },
  FAILED: { bg: "#ffcdd2", text: "#c62828", label: "Failed" },
  CANCELLED: { bg: "#f5f5f5", text: "#616161", label: "Cancelled" },
  REJECTED: { bg: "#ffebee", text: "#d32f2f", label: "Rejected" },
};

export const getReportStatusConfig = (status) => {
  return (
    REPORT_STATUS_COLORS[status] || {
      bg: "#f5f5f5",
      text: "#757575",
      label: status,
    }
  );
};

export const formatStatusLabel = (status) => {
  if (!status) return "";
  const config = getReportStatusConfig(status);
  return config.label;
};
